export enum MessageType {
  ERROR = 'error',
  INFO = 'success'
}

export interface MessageInterface {
  message: String;
  type: MessageType;
}

export class Message implements MessageInterface {
  message: String;
  type: MessageType;

  constructor(message: String, type: MessageType) {
    this.message = message;
    this.type = type;
  }

  public static error(text: string): Message {
    return new Message(text, MessageType.ERROR);
  }

  public static info(text: string): Message {
    return new Message(text, MessageType.INFO);
  }
}
